






import { Vue, Component, Prop } from 'vue-property-decorator';
import { BaseBlockViewObject } from '@/types/apiServerContract';

@Component
export default class BlockList extends Vue {
	@Prop({ required: true, type: Array }) blocks!: BaseBlockViewObject[];

	blockKey(block: BaseBlockViewObject, ix: number): string {
	    return block.id + ix;
	}
}
